import React from 'react';
import { createRoot } from 'react-dom/client';
import moment from 'moment';
import 'isomorphic-fetch';

import App from './App';

const locale = window.navigator.userLanguage || window.navigator.language;
moment.locale('ru');

const init = async () => {
	await store.init();
	console.log('store', store.model.isAuthorized);
	
	const container = document.getElementById('root');
	const root = createRoot(container);
	root.render(<App />);
};

init();
